module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "login-container boxed-login",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.signin($event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4"
  }, [_c('div', {
    staticClass: "login-form-container"
  }, [_c('div', {
    staticClass: "j-forms",
    attrs: {
      "id": "forms-login",
      "novalidate": "novalidate"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-form-content"
  }, [_c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "id": "login",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入正確的Email")])])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "placeholder": "密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.signin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("請輸入密碼")])])]), _vm._v(" "), _c('div', {
    staticClass: "response"
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-footer",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('button', {
    staticClass: "btn-block btn btn-info",
    on: {
      "click": _vm.signin
    }
  }, [_vm._v("登入")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "login-form-footer",
    staticStyle: {
      "padding-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('router-link', {
    staticClass: "btn-block btn btn-success",
    attrs: {
      "to": "signup"
    }
  }, [_c('i', {
    staticClass: "fas fa-user-plus"
  }), _vm._v("  馬上註冊，免費使用\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pointer"
  }, [_c('a', {
    staticClass: "gary",
    on: {
      "click": function($event) {
        _vm.resendValidateMailModal = true
      }
    }
  }, [_vm._v("點此重發驗證信")]), _c('span', {
    staticClass: "gary"
  }, [_vm._v("  |  ")]), _c('a', {
    staticClass: "gary",
    on: {
      "click": function($event) {
        _vm.forgotPasswordModal = true
      }
    }
  }, [_vm._v("忘記密碼？")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "login-page-footer"
  })]), _vm._v(" "), (_vm.resendValidateMailModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.resendValidateMailModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.resendValidateMailModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input login-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resend_email),
      expression: "resend_email"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入你的Email"
    },
    domProps: {
      "value": (_vm.resend_email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.resendValidateMail()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resend_email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.resendValidateMail()
      }
    }
  }, [_vm._v("\n                重發驗證信\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.resendValidateMailModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.forgotPasswordModal) ? _c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.forgotPasswordModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.forgotPasswordModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "name": "body"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input login-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resend_email),
      expression: "resend_email"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入你的Email"
    },
    domProps: {
      "value": (_vm.resend_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resend_email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer j-forms"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.resendForgotPasswordMail()
      }
    }
  }, [_vm._v("\n                重設密碼\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.forgotPasswordModal = false
      }
    }
  }, [_vm._v("\n                取消\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form-header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-pic",
    attrs: {
      "src": require("../../assets/img/logo3.png"),
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "login"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-account"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "password"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("重發驗證信")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("請輸入你之前註冊的Email，Flowneat將會重新寄送驗證信到您的信箱\n                "), _c('br'), _c('small', [_vm._v("（*請注意看看是否寄到垃圾收件夾，若真的在收件夾，建議您將Flowneat設定為安全聯絡人，以免錯過重要的提示信件）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("忘記密碼？")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("請輸入你之前註冊的Email，Flowneat將會重新寄送密碼重設信函到您的信箱\n                "), _c('br'), _c('small', [_vm._v("（*請注意看看是否寄到垃圾收件夾，若真的在收件夾，建議您將Flowneat設定為安全聯絡人，以免錯過重要的提示信件）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f7b1e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Login.vue
// module id = 677
// module chunks = 4